import http from '@utils/http';

export const getEmployees = (params = {}) =>
    http.get('/hr/employees', { params }).then((res) => {
        const payload = res.data ?? {};
        let list = payload.data ?? payload;
        if (list && typeof list === 'object' && !Array.isArray(list) && Array.isArray(list.data)) {
            list = list.data;
        }
        const data = Array.isArray(list) ? list : [];
        return {
            data,
            total: payload.total ?? data.length,
            page: payload.page ?? 1,
            limit: payload.limit ?? 10,
            totalPages: payload.totalPages ?? 1,
        };
    });

export const getEmployeeById = (id) => http.get(`/hr/employees/${id}`).then((res) => res.data?.data ?? res.data);
